/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';
import COLORS from '../../styles/Colors';

// TYPES

const types = {
  SHOW: 'app/systemNotification/SHOW',
  DISMISS: 'app/systemNotification/DISMISS',
};

const initialState = {
  phraseId: '',
  content: null,
  color: '',
};

// REDUCER

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SHOW:
      return _.assign({}, state, action.payload);
    case types.DISMISS:
      return _.assign({}, state, initialState);
    default:
      return state;
  }
}

// SELECTORS

export const selectors = {
  isNotificationAvailable: state => !!(state.systemNotification.phraseId || state.systemNotification.content),
  getNotificationMessage: state => state.systemNotification.phraseId,
  getNotificationContent: state => state.systemNotification.content,
  getNotificationColor: state => state.systemNotification.color,
};

// ACTION CREATORS

export const actions = {

  showNotification: (phraseId, color) => ({
    type: types.SHOW,
    payload: {
      phraseId,
      color,
    },
  }),

  showHintNotification: (phraseId) => ({
    type: types.SHOW,
    payload: {
      phraseId,
      color: COLORS.gsMedDark,
    },
  }),

  show: (content, color) => ({
    type: types.SHOW,
    payload: {
      content,
      color,
    },
  }),

  dismissNotification: () => ({
    type: types.DISMISS,
    payload: {},
  }),

};


// THUNK ACTION CREATORS
